import api from './client';

export type ActorType = 'system' | 'shipstation' | 'uniuni' | 'user' | 'batch_guard';

export interface OrderEvent {
  id: number;
  orderId: number;
  event_type: string;
  actor_type: ActorType;
  actor_id: number | null;
  actor_name: string | null;
  message: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

export const fetchOrderEvents = (orderId: string) =>
  api.get<{ events: OrderEvent[] }>(`/orders/${orderId}/events`).then((res) => res.data.events);
